export type RetentionPathPoint = {
  boundaryX: number;
  py: number;
};

/**
 * Retention values describe intervals, not samples at isolated points. Keep
 * each bucket flat and change vertically at its boundary so the chart never
 * invents gradual ramps between discrete one-second measurements.
 */
export function retentionStepPath(
  points: RetentionPathPoint[],
  width: number
): string {
  if (points.length === 0) return "";
  const commands = [`M 0 ${points[0].py.toFixed(1)}`];
  for (let index = 1; index < points.length; index += 1) {
    const point = points[index];
    const previous = points[index - 1];
    commands.push(
      `L ${point.boundaryX.toFixed(1)} ${previous.py.toFixed(1)}`,
      `L ${point.boundaryX.toFixed(1)} ${point.py.toFixed(1)}`
    );
  }
  commands.push(`L ${width} ${points[points.length - 1].py.toFixed(1)}`);
  return commands.join(" ");
}
